import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Stack
} from '@mui/material';
import heroImage from '../images/flooring-hero1.jpg';

const Hero = () => {
  return (
    <Box
      id="hero"
      sx={{
        background: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.5)), url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: {
          xs: 'fit-content',
          sm: 'fit-content',
          md: '100vh'
        },
        display: 'flex',
        alignItems: {
          xs: 'flex-start',
          sm: 'flex-start',
          md: 'center'
        },
        py: {
          xs: 10,
          sm: 10,
          md: 0
        },
        color: 'white',
        cursor: 'default',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              // border: '1px solid red',
              borderRadius: 2,
              p: 2,
              backgroundColor: 'rgba(0,0,0,0.0)'
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: 'logo.main',
                // fontWeight: 700,
                fontFamily: '"Nexa Slab Bold", serif',
                fontSize: { xs: '2.5rem', md: '4rem' },
                // mb: 2,
                // lineHeight: 1.2
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                textTransform: 'uppercase',
                letterSpacing: 4,
              }}
            >
              <span style={{ fontWeight: 900 }}>Maximal </span>
              <span style={{
                color: 'white',
                fontFamily: '"Nexa Slab Regular", serif',
                fontWeight: 500,
                letterSpacing: 2,
              }}>Flooring</span>
              <br />
              {/* <span style={{ color: '#ffd700' }}>Since 1995</span> */}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: 4,
                opacity: 0.9,
                fontWeight: 300,
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                // letterSpacing: 2,
              }}
            >
              Full service flooring and tile company delivering exceptional quality and reliability.
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              {/* <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: '#ffd700',
                  color: 'black',
                  fontWeight: 600,
                  px: 4,
                  py: 1.5,
                  '&:hover': {
                    backgroundColor: '#ffed4e'
                  }
                }}
              >
                View Our Projects
              </Button> */}
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: 'logo.main',
                  color: 'text.primary',
                  px: 4,
                  py: 1.5,
                  transition: 'all 0.2s ease',
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                    color: 'white'
                  }
                }}
                href="mailto:info@maximalflooring.com"
              >
                Get Quote
              </Button>
            </Stack>
          </Grid>
        </Grid>
        {/* <ShowcasePhotos /> */}
      </Container>
    </Box>
  );
};

export default Hero; 